import React, { FC, Dispatch } from 'react'
import VendNumber from 'vend-number'
import { TerminalEventMonitoring } from '@lightspeed-payments/payments-terminal-sdk'
import { ConnectingToTerminal } from '../../../modal-states/ConnectingToTerminal'
import { PaymentEvent } from '../hooks/use-lspay-payment-server-reducer/types'
import { useCreateTransaction } from '../hooks/use-create-transaction/useCreateTransaction'
import { SwiperError, TerminalInfo } from '../../../../helpers/lspay.types'

interface CreatingTransactionProps {
  amount: VendNumber
  currency: string
  registerId: string
  registerSaleId: string
  retailerPaymentTypeId: string
  registerSalePaymentId: string
  dispatch: Dispatch<PaymentEvent>
  withSurcharge?: boolean
  tipEligibleAmount?: VendNumber
  terminalMonitoringInstance: TerminalEventMonitoring | null
  setCancelProcessing: (cancelProcessing: () => void) => void
  setSwiperError: (swiperError: SwiperError) => void
  terminalInfo: TerminalInfo
}
export const CreatingTransaction: FC<CreatingTransactionProps> = ({
  amount,
  currency,
  registerId,
  registerSaleId,
  retailerPaymentTypeId,
  registerSalePaymentId,
  dispatch,
  withSurcharge,
  tipEligibleAmount,
  terminalMonitoringInstance,
  setCancelProcessing,
  setSwiperError,
  terminalInfo,
}) => {
  useCreateTransaction({
    amount,
    currency,
    registerId,
    registerSaleId,
    retailerPaymentTypeId,
    registerSalePaymentId,
    terminalMonitoringInstance,
    dispatch,
    withSurcharge,
    tipEligibleAmount,
    setCancelProcessing,
    setSwiperError,
    terminalInfo,
  })
  return (
    <ConnectingToTerminal
      headingType="sub-heading"
      integrationType="server-driven"
    />
  )
}
